import { useIntl } from 'react-intl';
import { useTheme } from '@mui/material';
import React, { useEffect, useState } from 'react';

import Highcharts from 'highcharts';
import Paper from 'components/paper';
import HighchartsReact from 'highcharts-react-official';
import { GraphData } from 'views/bluviu-nutrition/features/scenarios/types/scenario-result.type';

type Props = {
  graphData: GraphData[] | undefined;
};

const ViewGraph: React.FC<Props> = ({ graphData }) => {
  const intl = useIntl();
  const theme = useTheme();
  const [series, setSeries] = useState<any>([]);
  const PAGE_NAME_ID = 'bluViuNutrition.viewScenarioResultGt2.graph';

  console.log(graphData);

  const commonStyle = {
    fontFamily: 'DM Sans, Arial',
    color: theme.palette.darkBlue.main,
    fontSize: '12px',
  };

  const options: Highcharts.Options = {
    chart: {
      type: 'line',
      style: {
        ...commonStyle,
      },
    },
    credits: {
      enabled: false,
    },
    plotOptions: {
      series: {
        marker: {
          symbol: 'circle',
          radius: 8,
          enabled: false,
        },
      },
    },
    legend: {
      enabled: true,
      symbol: 'circle',
      symbolHeight: 12,
      symbolWidth: 12,
      symbolRadius: 8,
    },
    title: {
      text: '.',
      style: {
        fontFamily: 'DM Sans, Arial',
        fill: 'white',
        color: 'white',
      },
    },
    xAxis: {
      title: {
        text: intl.formatMessage({ id: `${PAGE_NAME_ID}.xWeek` }),
        style: {
          ...commonStyle,
          fontSize: '14px',
          textTransform: 'none',
          textAlign: 'left',
        },
      },
      type: 'treegrid',
      labels: {
        style: {
          ...commonStyle,
        },
      },
    },
    yAxis: {
      tickInterval: 1000,
      title: {
        text: intl.formatMessage({ id: `${PAGE_NAME_ID}.yWeight` }),
        style: {
          ...commonStyle,
          fontSize: '14px',
          textTransform: 'none',
        },
      },
      labels: {
        style: {
          ...commonStyle,
        },
      },
      stackLabels: {
        enabled: true,
        style: {
          ...commonStyle,
          fontWeight: '500',
          fontSize: '16px',
        },
      },
    },
    tooltip: {
      valueDecimals: 2,
      headerFormat: intl.formatMessage({ id: `${PAGE_NAME_ID}.productionWeek` }) + ': <b>{point.x}</b><br>',
      shared: true,
      valueSuffix: ' g',
      style: {
        fontSize: '13px',
      },
    },
    series: series,
  } as Highcharts.Options;

  useEffect(() => {
    const series = graphData
      ?.map((item) => ({
        name: item.feedPlan,
        data: item.graphValues.map((point) => [point.productionWeek, point.weight]),
      }))
      .sort((current, next) => current.name.localeCompare(next.name));

    setSeries(series);
  }, [graphData]);

  return (
    <Paper marginTop={4}>
      <HighchartsReact highcharts={Highcharts} options={options} />
    </Paper>
  );
};

export default ViewGraph;
